var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',[_vm._v("Required mappings")]),_c('ListEditor',{attrs:{"addAttribute":()=>{},"component":_vm.$options.RequiredAttributeField,"handleChangeListItem":()=>{},"handleRemoveListItem":()=>{},"headerText":"","listItems":_vm.attributesConfig.requiredAttributes,"showHeader":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }